import FoodOperatorService from 'src/modules/foodOperator/foodOperatorService';
import Errors from 'src/modules/shared/error/errors';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'FOODOPERATOR_VIEW';

const foodOperatorViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,
  FIND_RESET: `${prefix}_FIND_RESET`,

  reset: () => async (dispatch) => {
    dispatch({
      type: foodOperatorViewActions.FIND_RESET,
    });
  },

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: foodOperatorViewActions.FIND_STARTED,
      });

      const record = await FoodOperatorService.find(id);

      dispatch({
        type: foodOperatorViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: foodOperatorViewActions.FIND_ERROR,
      });

      navigateTo('/library/food-operator');
    }
  },
};

export default foodOperatorViewActions;
